import { withLatestFrom } from 'rxjs/operators';

/**
 * @param {Observable<Asset>}
 * @param {Observable<Config>}
 * @returns {Observable<[Asset, Config]>}
 */

const createAssetUpdateWithConfigStream = (
    assetUpdate$,
    configUpdate$
) =>
    assetUpdate$
        .pipe(
            withLatestFrom(configUpdate$)
        );

export default createAssetUpdateWithConfigStream;

